import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('/checklists', { params: params })
      .then(response => {
        return response.data
      })
  },
  get(checklistId) {
    return axios.get(`/checklists/${checklistId}`).then(response => {
      return response.data
    })
  },
  destroy(id) {
    return axios.delete(`/inventory-items/${id}`)
  }
}
